/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageContent = /** @class */ (function () {
            function ApPageContent($timeout, $window) {
                this.$timeout = $timeout;
                this.$window = $window;
                this.controller = Directives.ApPageContentController;
                this.controllerAs = 'ctrl';
                this.replace = false;
                this.restrict = 'A';
                this.scope = {};
                this.templateUrl = 'app/directives/ap-page-content/template.html';
            }
            ApPageContent.factory = function () {
                var directive = function ($timeout, $window) {
                    return new ApPageContent($timeout, $window);
                };
                directive['$inject'] = ['$timeout', '$window'];
                return directive;
            };
            return ApPageContent;
        }());
        Directives.ApPageContent = ApPageContent;
        angular
            .module('app.Directives')
            .directive('apPageContent', ApPageContent.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
